import { render, staticRenderFns } from "./ProductStyles.vue?vue&type=template&id=0433ec90&scoped=true"
import script from "./ProductStyles.vue?vue&type=script&lang=js"
export * from "./ProductStyles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0433ec90",
  null
  
)

export default component.exports